import { useCallback, useEffect } from 'react';
import { selectors, getAll, loaded, CurrentStripeSubscription } from '../redux/features';
import { useSelector, useDispatch } from 'react-redux';

export default function useFeatures(
    companyType: string,
    tenantId?: string,
    fetchStripeData = false,
): [
    ReturnType<typeof selectors.selectAll>,
    'idle' | 'pending',
    CurrentStripeSubscription,
    () => Promise<unknown>,
] {
    const dispatch = useDispatch();
    const reduxState = useSelector((state: any) => {
        return state.features;
    });
    const items = selectors.selectAll(reduxState);
    const loading = reduxState.loading;
    const currentStripeSubscription = reduxState.currentStripeSubscription ?? null;

    const reload = useCallback(async () => {
        try {
            await dispatch(getAll(companyType, tenantId, fetchStripeData));
        } catch (error) {
            dispatch(loaded('idle'));
        }
    }, [dispatch, companyType, tenantId, fetchStripeData]);

    useEffect(() => {
        reload().catch(() => {});
    }, [reload]);

    return [
        items,
        loading,
        currentStripeSubscription,
        reload,
    ];
};
